module.exports = __webpack_public_path__ + "static/roussillonLogo_small-08d6761af2ccaf7085d4aded643ec032.jpeg";